// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--bIQBE","icon":"_93444fe79c--icon--mShIs","remoteness":"_93444fe79c--remoteness--TWk4R"};